import { Controller } from "react-hook-form";
import { IFilterItem } from "../../../components/FilterItem/FilterItem";
import { ISelect } from "../ISelect";

export const ControllerWrappedSelect = (props: IFilterItem) => {
  const { methods, el } = props;

  const {
    control,
    setValue,
    formState: { errors },
  } = methods;

  const {
    name,
    defaultValue,
    onChange,
    clearAfterChangeName = "",
    ...rest
  } = el;
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => (
        <ISelect
          field={field}
          error={errors?.[name]?.message}
          onChange={(val) => {
            onChange(val);
            if (clearAfterChangeName) {
              setValue(clearAfterChangeName, null);
            }
          }}
          {...rest}
        />
      )}
    />
  );
};
